/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=7bf0f798"
const script = {}

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__